import { wanModels, type WanModel } from './catalog';

export const legacyModelKey = 'wan-2.2';

/** Navigation follows the input/output task; model variants belong in the form. */
export const generatorCategories = [
  { id: 'speech-to-video', legacy: true, operations: ['speech-to-video'], label: ['语音转视频', 'Speech to Video'], description: ['', ''] },
  { id: 'image-to-video', legacy: true, operations: ['image-to-video', 'image-to-video-fast', 'image-to-video-flash', 'image-to-video-pro'], label: ['图片转视频', 'Image to Video'], description: ['', ''] },
  { id: 'text-to-video', legacy: true, operations: ['text-to-video', 'text-to-video-fast'], label: ['文本转视频', 'Text to Video'], description: ['', ''] },
  { id: 'video-to-video', legacy: true, operations: ['video-edit'], label: ['视频转视频', 'Video to Video'], description: ['', ''] },
  { id: 'video-extend', legacy: false, operations: ['video-extend'], label: ['视频续写', 'Video Extend'], description: ['延续原视频的画面与动作，生成后续片段', 'Continue an existing video with new scenes and motion'] },
  { id: 'reference-to-video', legacy: false, operations: ['reference-to-video', 'reference-to-video-flash'], label: ['参考生视频', 'Reference to Video'], description: ['通过参考图片、视频与音频创作视频内容', 'Create videos using image, video and audio references'] },
  { id: 'wan22-animate', legacy: true, operations: ['animate'], label: ['Wan2.2 Animate', 'Wan2.2 Animate'], description: ['', ''] },
  { id: 'text-to-image', legacy: true, operations: ['text-to-image', 'text-to-image-pro'], label: ['文本转图片', 'Text to Image'], description: ['', ''] },
  { id: 'image-to-image', legacy: false, operations: ['image-edit', 'image-edit-pro'], label: ['图片编辑', 'Image to Image'], description: ['通过提示词和参考图片编辑、创作图像', 'Edit and create images from prompts and reference images'] },
] as const;

export type GeneratorCategory = typeof generatorCategories[number];
export type GeneratorCategoryId = GeneratorCategory['id'];
export const getGeneratorCategory = (id: string) => generatorCategories.find(category => category.id === id);
export const categoryModels = (id: string) => {
  const category = getGeneratorCategory(id);
  return wanModels.filter(model => (category?.operations as readonly string[] | undefined)?.includes(model.operation));
};

export function resolveCategoryModel(id: string, requested?: string): string {
  const category = getGeneratorCategory(id);
  const models = categoryModels(id);
  if (models.some(model => model.key === requested)) return requested!;
  if (category?.legacy) return models.find(model => model.version === '2.2')!.key;
  const standardModels = models.filter(model => !/-(fast|flash|pro)$/.test(model.operation));
  return standardModels.find(model => model.version === '3.0')?.key || standardModels.at(-1)?.key || '';
}

export function wanModelLabel(model: WanModel): string {
  const variant = model.version === '2.2' && /[ti]2v-/.test(model.id) ? (model.id.endsWith('720p') ? '720p' : '480p') : model.operation.endsWith('-fast') ? 'Fast' : model.operation.endsWith('-flash') ? 'Flash'
    : model.operation.endsWith('-pro') ? 'Pro' : '';
  return `Wan ${model.version.replace('-prime', ' Prime')}${variant ? ` · ${variant}` : ''}`;
}
